import React, { useState, useRef, useEffect } from 'react';
import { useScreenType, useScreenTypeUpdate } from "../../components/context/MixContext";
import { motion } from "framer-motion";
import { useIdleTimerContext } from 'react-idle-timer';

import MenuLink from '../MenuLink/MenuLink';


// import Swiper JS
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
// import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';




import './Menu.css';


const Menu = () => {

    // Screen type
    const getScreenType = useScreenType();
    const setScreenType = useScreenTypeUpdate();
    const _idletimer = useIdleTimerContext();

    const swiper = new Swiper('.swiper', {
        // configure Swiper to use modules
        modules: [Navigation, Pagination],
        slidesPerView: 1,
        spaceBetween: 10,
        // centeredSlides: true,
        // slidesPerView: 'auto',

        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },

        // Navigation arrows
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },

        breakpoints: {
            // when window width is >= 640px
            640: {
                slidesPerView: 2,
                spaceBetween: 20,
            },
            // when window width is >= 768px
            960: {
                slidesPerView: 3.4,
                spaceBetween: 30,
            },
        }

    });

    useEffect(() => {
        setScreenType('menu');
        _idletimer.start();
    }, []);


    return (
        <div id="menu" className="menu-wrap" data-feedback-id="menu" data-feedback-label="Menu screen">
            <div className="menu-bg"></div>
            <motion.div className="title"
                initial={{ opacity: 0, y: -100 }}
                animate={{ opacity: 1, y: 0 }} 
                transition={{ delay: .1, duration: .5, type: "spring", damping: 10, mass: 0.75, stiffness: 100 }}
            >
                <h1>Elucirem™ (gadopiclenol) Injection<br />Clinical Image Library</h1>
                <h2>Approved in 2022, the 1st low-dose macrocyclic GBCA with the highest relaxivity<sup>1-3</sup></h2>
            </motion.div>


                <div className="swiper menu-swiper">


                    <div className="swiper-wrapper">

                        <div className="swiper-slide">
                            <MenuLink indx="0" delay="0.1" count="11" />
                        </div>
                        <div className="swiper-slide">
                            <MenuLink indx="1" delay="0.2" count="2"/>
                        </div>
                        <div className="swiper-slide">
                            <MenuLink indx="2" delay="0.3" count="6"/>
                        </div>
                        <div className="swiper-slide">
                            <MenuLink indx="3" delay="0.4" count="6"/>
                        </div>
                        <div className="swiper-slide">
                            <MenuLink indx="4" delay="0.5" count="3"/>
                        </div>
                        <div className="swiper-slide">
                            <MenuLink indx="5" delay="0.5" count="2"/>
                        </div>

                    </div>

                    <div className="swiper-pagination"></div>
                    <div className="swiper-button-prev"></div>
                    <div className="swiper-button-next"></div>

                    </div>

        </div>
    );
};

export default Menu;